import actionKeys from './userActionKeys';
import * as service from './userService';

const callService = (actionKey, apiMethod, ...params) => ({
  type: actionKey,
  payload: {
    data: params,
    promise: service[apiMethod](...params),
  },
});
export const getUser = () =>
  callService(actionKeys.GET_USER, 'getUser');

export default { getUser };



// WEBPACK FOOTER //
// ./src/app/common/user/userActions.js